import NavigationLinks from './navigationLinks/navigationLinks.component';
import FooterBottom from './footerBottom/footerBottom.component';
import DescriptionSection from './descriptionSection/descriptionSection.component';

export { NavigationLinks, FooterBottom, DescriptionSection };
